import React, { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Header from './Header';
import UnifiedSidebar from './UnifiedSidebar';
import { rolesRoutes } from '../../security/rolesRoutes';
import { useAuth } from '../../contexts/AuthContext';
import SessionWarningModal from './SessionWarningModal';
import PoweredByFooter from '../ui/PoweredByFooter';
import { Skeleton } from '../ui/Skeleton';

const PrivateRoute = () => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />;
  }

  const userRole = user?.role;

  if (userRole && rolesRoutes[userRole]) {
    const allowedPaths = rolesRoutes[userRole];
    const isAllowed = allowedPaths.some((path) => location.pathname.startsWith(path));
    if (!isAllowed) {
      return <Navigate to="/unauthorized" />;
    }
  }

  return (
    <div className="flex min-h-screen bg-background">
      <UnifiedSidebar />

      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header />
        <main className="flex-1 overflow-auto p-6">
          <Suspense
            fallback={
              <div className="flex flex-col gap-6">
                <Skeleton className="h-10 w-64 rounded-lg" />
                <Skeleton className="h-96 w-full rounded-lg" />
              </div>
            }
          >
            <Outlet />
          </Suspense>
          <PoweredByFooter className="mt-8" />
        </main>
      </div>

      <SessionWarningModal />
    </div>
  );
};

export default PrivateRoute;
